import * as z from 'zod'
import type { OrderImageItem, OrderImagesFeed } from '@/api/orders/types'

export const orderImageItemSchema: z.ZodType<OrderImageItem> = z.object({
  orderItemId: z.number(),
  orderNumber: z.string(),
  orderedAt: z.string(),
  productName: z.string(),
  imageUrl: z.string().nullable(),
  price: z.number(),
  currency: z.string(),
  quantity: z.number(),
  channel: z.string(),
  status: z.string(),
})

export const orderImagesFeedSchema: z.ZodType<OrderImagesFeed> = z.object({
  items: z.array(orderImageItemSchema),
  generatedAt: z.string(),
  nextCursor: z.string().nullable(),
})
